module.exports = __webpack_public_path__ + "static/media/storyRegister2.30184588.png";